import { HomeEvalJobDao, HomeEvalResultDao } from '@rock/db-admin';
import type { HomeEvalJobId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atomFamily } from 'jotai/utils';

const JOBS_LIMIT = 100;
const homeEvalJobDao = new HomeEvalJobDao(JOBS_LIMIT);
const homeEvalResultDao = new HomeEvalResultDao();

export const homeEvalJobsState = homeEvalJobDao.homeEvalJobsAtom();

export const homeEvalJobState = atomFamily(
    (jobId: HomeEvalJobId | undefined) => homeEvalJobDao.homeEvalJobAtom(jobId),
    shallowEqual,
);

export const homeEvalResultsByJobIdState = atomFamily(
    (jobId: HomeEvalJobId | undefined) => homeEvalResultDao.homeEvalResultsForJobAtom(jobId),
    shallowEqual,
);
